window.AlteraSenhaPage={
    data: {
        formHandler: null
    },
    watch: {
        required: ($refField, $refSpan) => {
            if (!FormGenericValidator.required($refField.val())) {
                BSForm.error($refField, $refSpan, "Este campo deve ser preenchido");
                return false;
            }
            else return true;
        },
        password() {
            if (!AlteraSenhaPage.watch.required($('#senha'), $('#spanSenhaErro'))) return false;
            else {
                if (FormGenericValidator.password($('#senha').val())) {
                    BSForm.success($('#senha'), $('#spanSenhaErro'));
                    return true;
                }
                else {
                    BSForm.error($('#senha'), $('#spanSenhaErro'), "A senha deve conter no mínimo 6 caractéres");
                    return false;
                }
            }
        },
        password_confirmation(NOT_MECHANICAL) {
            if(NOT_MECHANICAL) {
                if (FormGenericValidator.required($('#csenha').val())) {
                    if (FormGenericValidator.passwordConfirm($('#senha').val(), $('#csenha').val())) {
                        BSForm.success($('#csenha'), $('#spanCSenhaErro'));
                        return true;
                    }
                    else {
                        BSForm.error($('#csenha'), $('#spanCSenhaErro'), "As senhas nao coincidem");
                        return false;
                    }
                } else return false;
            }else{
                if (AlteraSenhaPage.watch.required($('#csenha'),$('#spanCSenhaErro'))) {
                    if (FormGenericValidator.passwordConfirm($('#senha').val(), $('#csenha').val())) {
                        BSForm.success($('#csenha'), $('#spanCSenhaErro'));
                        return true;
                    }
                    else {
                        BSForm.error($('#csenha'), $('#spanCSenhaErro'), "As senhas nao coincidem");
                        return false;
                    }
                } else return false;
            }
        },
        form_send(){
            let self=AlteraSenhaPage;
            if(
                self.watch.password() &
                self.watch.password_confirmation()
            ){
                    $('#formRecoveryPassword').unbind('submit',self.data.formHandler);
                    $('#formRecoveryPassword').unbind('submit',self.watch.form_send);
                    $('#formRecoveryPassword').submit();
            }
        }
    },
    load(){
        let self=AlteraSenhaPage;
        self.data.formHandler=function (e) {
            e.preventDefault();
            return false;
        };
        $('#formRecoveryPassword').on('submit',self.data.formHandler);
        $('#formRecoveryPassword').on('submit',self.watch.form_send);
        $('#formRecoveryPassword #senha').on('change blur',() => {
             self.watch.password();
             self.watch.password_confirmation(true);
        });
        $('#formRecoveryPassword #csenha').on('change blur',() => {
             self.watch.password_confirmation();
        });
    }
};
AlteraSenhaPage.load();